export var ECharacterCapable;
(function (ECharacterCapable) {
    ECharacterCapable[ECharacterCapable["Charcater_Gravity"] = 0] = "Charcater_Gravity";
    ECharacterCapable[ECharacterCapable["Charcater_CollisionGroup"] = 1] = "Charcater_CollisionGroup";
    ECharacterCapable[ECharacterCapable["Charcater_WorldPosition"] = 2] = "Charcater_WorldPosition";
    ECharacterCapable[ECharacterCapable["Charcater_Move"] = 3] = "Charcater_Move";
    ECharacterCapable[ECharacterCapable["Charcater_Jump"] = 4] = "Charcater_Jump";
    ECharacterCapable[ECharacterCapable["Charcater_StepOffset"] = 5] = "Charcater_StepOffset";
    ECharacterCapable[ECharacterCapable["Character_UpDirection"] = 6] = "Character_UpDirection";
    ECharacterCapable[ECharacterCapable["Character_FallSpeed"] = 7] = "Character_FallSpeed";
    ECharacterCapable[ECharacterCapable["Character_SlopeLimit"] = 8] = "Character_SlopeLimit";
    ECharacterCapable[ECharacterCapable["Character_PushForce"] = 9] = "Character_PushForce";
    ECharacterCapable[ECharacterCapable["Character_Radius"] = 10] = "Character_Radius";
    ECharacterCapable[ECharacterCapable["Character_Height"] = 11] = "Character_Height";
    ECharacterCapable[ECharacterCapable["Character_offset"] = 12] = "Character_offset";
    ECharacterCapable[ECharacterCapable["Character_Skin"] = 13] = "Character_Skin";
    ECharacterCapable[ECharacterCapable["Character_minDistance"] = 14] = "Character_minDistance";
    ECharacterCapable[ECharacterCapable["Character_EventFilter"] = 15] = "Character_EventFilter";
    ECharacterCapable[ECharacterCapable["Character_SimulateGravity"] = 16] = "Character_SimulateGravity";
    ECharacterCapable[ECharacterCapable["Character_IsOnGround"] = 17] = "Character_IsOnGround";
})(ECharacterCapable || (ECharacterCapable = {}));
